import gql from 'graphql-tag';

export const GET_SUBPRIME_AGENT_SESSIONS = gql`
  query GetSubprimeAgentSessions($vendorOpportunityId: ID!) {
    subprimeAgent {
      getSessionsByVo(vendorOpportunityId: $vendorOpportunityId) {
        id
        sessionId
        status
        wantsFinancing
        downpaymentFunds
        collateral
        guarantor
        notes
        name
        phone
        completedAt
        stoppedByDealer
        optedOut
        createdAt
        modifiedAt
      }
    }
  }
`;
